module.exports = __webpack_public_path__ + "static/media/bmw_zertifikat_2018.f89aa51c.jpg";